import React, { useRef } from "react";

import PackingListTemplate from "./PackingListTemplate";

const defaultPackingData = {
  exporter: {
    companyName: "TANDA RUBBER WORKS",
    address:
      "0, NEHRU NAGAR TANDA, AMBEDKAR NAGAR, UTTAR PRADESH, 224190",
    country: "India",
    phone: "+916394750886",
    contactPerson: "SHAKEEL AHMAD",
    gstin: "09CXQPA7585K1ZN",
    iec: "CXQPA7585K",
  },

  invoice: {
    invoiceDate: "01 May 2026",
    referenceNumber: "TRWOO7",
    pages: "1 of 1",
  },

  consignee: {
    companyName:
      "SENER TEKSTIL MAKINA SAN VE TIC LTD",

    address:
      "STI IOSB ZIYAGOKALP MAH GIYISANATKARLARI SIT.4B BLOK NO:409 BASAKSEHIR",

    city: "ISTANBUL",

    country: "Turkey",

    phone: "+905335736880",

    contactPerson: "MS. SENER",
  },

  shipmentDetails: {
    methodOfDispatch: "Sea Maritime",

    typeOfShipment: "LCL",

    countryOfOrigin: "India",

    countryOfFinalDestination:
      "Turkey",
  },

  packingInformation: {
    packingInfo:
      "SHRINKING RUBBER BELT ROLL 76 INCH WIDTH LENGTH 76INCH GROSS WEIGHT 850 APPROX",
  },

  ports: {
    portOfLoading: "ICD PANKI KANKUR",

    portOfDischarge:
      "Nhava Sheva (Jawaharlal Nehru)",

    finalDestination:
      "istanbul sea port",

    portOfDelivery:
      "AMBARLI PORT TURKEY",
  },

  goods: [
    {
      productCode: "",

      descriptionOfGoods:
        "SHRINKING RUBBER BELT ROLL",

      unitQuantity: "1",

      netWeightKg: "850",

      grossWeight: "1,000",
    },
    {
      productCode: "",

      descriptionOfGoods:
        "SHRINKING RUBBER BELT ROLL",

      unitQuantity: "1",

      netWeightKg: "850",

      grossWeight: "1,000",
    },{
      productCode: "",

      descriptionOfGoods:
        "SHRINKING RUBBER BELT ROLL",

      unitQuantity: "1",

      netWeightKg: "850",

      grossWeight: "1,000",
    },
    {
      productCode: "",

      descriptionOfGoods:
        "SHRINKING RUBBER BELT ROLL",

      unitQuantity: "1",

      netWeightKg: "850",

      grossWeight: "1,000",
    },{
      productCode: "",

      descriptionOfGoods:
        "SHRINKING RUBBER BELT ROLL",

      unitQuantity: "1",

      netWeightKg: "850",

      grossWeight: "1,000",
    },

  ],

  totals: {
    totalThisPageQuantity: "1",

    totalThisPageWeight: "850",

    consignmentTotalQuantity: "1",

    consignmentTotalWeight: "850",
  },

  signatory: {
    company: "TANDA RUBBER WORKS",

    authorizedPersonFirstName:
      "SHAKEEL",

    authorizedPersonLastName:
      "AHMAD",

    signatureText: "shakeel ahmad",
  },
};

const PackingListPreview = ({invoiceData, invoiceDate, onEdit}) => {
  const pdfRef = useRef();


  return (
    <div>

      <PackingListTemplate
        ref={pdfRef}
        invoiceData={invoiceData}
        invoiceDate={invoiceDate}
        onEdit={onEdit}
      />

    </div>
  );
};

export default PackingListPreview;